module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAOlJREFUKBVjnDlz5n8GcgA5GkF6mECWARkpxFo6e/bsNJBaRpBuRkbGS////7/Dw8OTEh0d/R6bIfPmzRP9/fv3XKCcNBAbgW0UEBAwBWp++OXLl8uzZs2yR9cINNwbqOkSUM0VoJwFSB5sY3p6OiOIA1TgBqQWAvE8QUHBuvfv37MDFfcCXeMBFIsFqjsCpEHqIH4EcUAAKLGLlZVVD6jYEKhpN1DoAhBzcXNz68M0gdSBAAuEQpBJSUmvgTwvoJNLgAY8SE1NXYOQRbAwNMKk0tLSemBsbDQ4cLBJEBIjWyM4VAmZjk0eAGySU0qwj7IWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat/noread.png
// module id = jE0l
// module chunks = 0